module.exports = __webpack_public_path__ + "static/media/background.7b2d7c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/background.jpg
// module id = 1694
// module chunks = 0